import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import SubcontractorDetailPage from "@/pages/admin/SubcontractorDetailPage";

export const Route = createFileRoute("/_admin/admin/subcontractors/$id")({
  head: () => pageHead("Admin · Subcontractors", "AKIVA admin · subcontractors portal.", "/admin/subcontractors/$id", true),
  component: SubcontractorDetailPage,
});
